export class MatTableParameter {
}
